import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  PlanCard,
  PlanWrapper,
  PlansGlobalWrapper,
  RadioCheck,
  RadioControl,
  RadioUncheck,
  TrialText,
} from './index.styled';
import usePlan from './usePlan';
import roles from '../../utils/constants/roles';
import { text } from '../text';

/** @type {(props: { planSelected }) => JSX.Element} */
export default ({ planSelected }) => {
  const intl = useIntl()
  const { plans, toggleCheck } = usePlan();

  useEffect(() => {
    if (planSelected && planSelected === roles.BUSINESS_MAIN) {
      toggleCheck({ id: plans[1].id });
    }
  }, [planSelected]);

  const checkById = (id) => () => {
    toggleCheck({ id });
  };

  const wrap = (arr) => {
    return arr.map((data) => (
      <PlanWrapper>
        <PlanCard
          onClick={checkById(data.id)}
          title={data.name}
          list={data.list}
          color={data.hex}
          description={data.descrip}
          price={data.price}
          to={`/pricing?pkg=${data.param}`}
        />
        <RadioControl
          value=''
          onClick={checkById(data.id)}
          control={data.checked ? <RadioCheck /> : <RadioUncheck />}
          label={intl.formatMessage({ id: 'planOption.selectThisPlan' })}
        />
        {data.trials > 0 && (
          <TrialText>
            {text('planOption.selectThisPlanTrial', { trialDays: data.trials })}
          </TrialText>
        )}
      </PlanWrapper>
    ));
  };

  return <PlansGlobalWrapper>{wrap(plans)}</PlansGlobalWrapper>;
};
